// Width of each field on the Pricing tab: 90 spacing steps, 360 px. Fields shrink in a narrower card.
export const PRICING_FIELD_WIDTH = 90;
